import { render, staticRenderFns } from "./PackagePondDetail.vue?vue&type=template&id=a07b2b4c&scoped=true"
import script from "./PackagePondDetail.vue?vue&type=script&lang=js"
export * from "./PackagePondDetail.vue?vue&type=script&lang=js"
import style0 from "./PackagePondDetail.vue?vue&type=style&index=0&id=a07b2b4c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07b2b4c",
  null
  
)

export default component.exports